import { render, staticRenderFns } from "./singleWalletTransaction.vue?vue&type=template&id=1f91fe22"
import script from "./singleWalletTransaction.vue?vue&type=script&lang=js"
export * from "./singleWalletTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports